import { createSelector } from 'reselect';

import {
  selectEntitiesMissionsEntityImageUrl,
  selectEntitiesMissionsEntityOperationType,
  selectEntitiesMissionsEntityOptInEnabled,
  selectEntitiesMissionsEntityTitle,
} from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { selectUserConnected } from '../../../../selectors/user/userPrimary.selector';
import { Selector } from '../../../../types/selectors';
import { selectUserMissionHasUserRegistered, selectUserMissionStatus } from '../../selectors/userMissions';
import { MissionOperationType, MissionOperationTypes } from '../../types/state/missions';
import { UserMissionStatuses } from '../../types/state/userMissions';
import { selectMissionBetRedirectionCallback } from '../MissionDetailsBetRedirectionButton/MissionDetailsBetRedirectionButton.selector';
import { selectMissionFreebetsPotentialGain } from '../MissionFreebetsPotentialGain/MissionFreebetsPotentialGain.selector';

type MissionBannerContainerPropsType = {
  backgroundURL?: string | null;
  optInRequired: boolean;
  operationType?: MissionOperationType;
  showProgressBar: boolean;
  betRedirectionOnClick: () => void;
  title?: string;
  hasFreebets: boolean;
};

const selectMissionBannerContainerProps: Selector<MissionBannerContainerPropsType> = createSelector(
  [
    selectEntitiesMissionsEntityImageUrl,
    selectUserConnected,
    selectUserMissionHasUserRegistered,
    selectUserMissionStatus,
    selectEntitiesMissionsEntityOperationType,
    selectEntitiesMissionsEntityOptInEnabled,
    selectMissionBetRedirectionCallback,
    selectEntitiesMissionsEntityTitle,
    selectMissionFreebetsPotentialGain,
  ],
  (
    backgroundURL,
    isUserConnected,
    hasUserRegistered,
    userMissionStatus,
    operationType,
    optInRequired,
    betRedirectonCallback,
    title,
    amount,
  ) => ({
    backgroundURL,
    optInRequired,
    operationType,
    showProgressBar:
      isUserConnected &&
      hasUserRegistered &&
      (!userMissionStatus || userMissionStatus === UserMissionStatuses.OPEN) &&
      operationType === MissionOperationTypes.MISSION,
    betRedirectionOnClick: betRedirectonCallback ?? (() => false),
    title,
    hasFreebets: !!amount,
  }),
);

export default selectMissionBannerContainerProps;
